"use client";
function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import React, { useEffect, useState } from "react";
export default function LogoBanner(props) {
    var _useState = _sliced_to_array(useState(0), 2), slideIndex = _useState[0], setSlideIndex = _useState[1];
    var _useState1 = _sliced_to_array(useState(true), 2), fadeIn = _useState1[0], setFadeIn = _useState1[1];
    var slidesToShow = 6;
    var getNextSlideIndex = function(currentIndex) {
        var nextIndex = currentIndex + slidesToShow;
        if (props.logos && nextIndex >= props.logos.length) {
            nextIndex = nextIndex - props.logos.length;
        }
        return nextIndex;
    };
    useEffect(function() {
        var slideTimer = setInterval(function() {
            setFadeIn(false);
            setTimeout(function() {
                setSlideIndex(function(prevSlideIndex) {
                    return getNextSlideIndex(prevSlideIndex);
                });
                setFadeIn(true);
            }, 100);
        }, 4300);
        return function() {
            return clearInterval(slideTimer);
        };
    }, []);
    var getSlideLogos = function(slideIndex) {
        var logosToShow = [];
        for(var i = slideIndex; i < slideIndex + slidesToShow; i++){
            var index = i;
            if (props.logos) {
                if (index >= props.logos.length) {
                    index = index - props.logos.length;
                }
                logosToShow.push(props.logos[index]);
            }
        }
        return logosToShow;
    };
    return /*#__PURE__*/ React.createElement("div", {
        className: "px-6 md:px-14 mb-20 md:mb-32"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "max-w-7xl mx-auto relative h-12 md:h-14 xl:h-20"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "grid grid-cols-6 absolute top-0 left-0 w-full",
        "data-chromatic": "ignore"
    }, getSlideLogos(slideIndex).map(function(logo, index) {
        /*#__PURE__*/ return React.createElement("div", {
            key: index,
            className: "focus px-2.5 md:px-6 lg:px-10 flex items-center justify-center border-r border-r-gray-400 md:py-2 lg:py-4 last:border-none transition duration-1100 ".concat(fadeIn ? "opacity-100" : "opacity-0")
        }, /*#__PURE__*/ React.createElement("img", {
            height: "50",
            className: "grayscale transition-all max-w-full xl:max-w-[140px] max-h-[15px] sm:max-h-[25px] md:max-h-[40px] xl:max-h-[50px] inline-block",
            src: "".concat(logo === null || logo === void 0 ? void 0 : logo.image),
            alt: "".concat(logo === null || logo === void 0 ? void 0 : logo.label)
        }));
    }))));
}
